export default __webpack_public_path__ + "static/media/Group 8534@2x.a6979bbb.jpg";